import { useAccidentsServiceAccidentsTerritoriesList } from '@insurance/api/queries'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useAccidentInsuranceValues } from './AccidentInsuranceContext'
import { formProps } from './utils'

export const Territory = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { territoryProps } = formProps(t)
  const { isEditable } = useAccidentInsuranceValues()

  const { data } = useAccidentsServiceAccidentsTerritoriesList({})

  const options = data?.map(({ code }) => ({ label: t(code), value: code }))

  return (
    <Form.Item {...territoryProps} rules={[required]}>
      <RadioCardGroup options={options} disabled={isEditable} />
    </Form.Item>
  )
}
